/* @flow */

type Listener = {
  el: Element,
  eventType: string,
  eventHandler: EventHandler,
  useCapture: boolean
};

export default class ListenerManager {
  listeners: Array<Listener> = [];

  constructor() {
    (this: any).add = this.add.bind(this);
    (this: any).removeAll = this.removeAll.bind(this);
  }

  add(
    el: Element,
    eventType: string,
    eventHandler: EventHandler,
    useCapture: boolean = false
  ): void {
    el.addEventListener(eventType, eventHandler, useCapture);
    this.listeners.push(({el, eventType, eventHandler, useCapture}: Listener));
  }

  removeAll(): void {
    this.listeners.forEach(({
        el,
        eventType,
        eventHandler,
        useCapture
      }: Listener) => {
      el.removeEventListener(eventType, eventHandler, useCapture);
    });
    this.listeners = [];
  }
}



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/utilities/ListenerManager.js